// import React, { useState, useEffect, useRef } from 'react';
// import {Link as RouterLink} from "react-router-dom";
// import {Link as ScrollLink} from "react-scroll";
// import ScrollToTop from '../../components/layout/Scroll';
// import Img1 from "../../assets/Menu1.jpg";
// import Img2 from "../../assets/Menu2.jpg";
// import Img3 from "../../assets/Menu3.jpg";

// const menuExpress= [
//     {
//         image: Img1,
//         title: "Express Bowl Ayam"
//     },
//     {
//         image: Img2,
//         title: "Express Bowl Ikan"
//     },
//     {
//         image: Img3,
//         title: "Express Bowl Mix",
//         description: "(Udang, Ikan, dan Ayam)"
//     },
// ];

// const KategoriMenu = () => {
//     const [isOpen, setIsOpen] = useState(false);
//     const [isScrolled, setIsScrolled] = useState(false);
//     const [activeLink, setActiveLink] = useState("");
//     const scrollContainterRef = useRef(null);
//     const [isDragging, setIsDragging] = useState(false);
//     const [startX, setStartX] = useState(0);
//     const [scrollLeft, setScrollLeft] = useState(0);

//     const linkClass = `relative pb-1 font-bold hover:text-pink-700 transition-all duration-300 
//     whitespace-nowrap ${
//         isScrolled ? "text-pink-700" : "text-black"
//     } hover:after:content-[''] hover:after:h-0.5 hover:after:bg-pink-500`;

//     const activeLinkClass = `after:content-[''] after:absolute 
//     after:left-0 after:bottom-0 
//     after:w-full after:h-0.5 after:bg-pink-200 
//     after:transition-all after:duration-300`;

//     // Fungsi untuk handle mouse down (mulai drag)
//     const handleMouseDown = (e) => {
//         setIsDragging(true);
//         setStartX(e.pageX - scrollContainterRef.current.offsetLeft);
//         setScrollLeft(scrollContainterRef.current.scrollLeft);
//     };

//     // Fungsi untuk handle mouse leave (selama drag)
//     const handleMouseLeave = () => {
//         setIsDragging(false);
//     };

//     // Fungsi untuk handle mouse up (akhir drag)
//     const handleMouseUp =() =>{
//         setIsDragging(false);
//     };

//     // Fungsi untuk handle mouse move (selama drag)
//     const handleMouseMove = (e) => {
//         if (!isDragging) return;
//         const x = e.pageX - scrollContainterRef.current.offsetLeft;
//         const walk = (x - startX) * 2; // multiply for faster scroll
//         scrollContainterRef.current.scrollLeft = scrollLeft - walk;
//     };

//     // Efek untuk scroll horizontal dengan mouse wheel
//     useEffect(() => {
//         const scrollContainer = scrollContainterRef.current;
//         const handleWheel = (e) => {
//             if (scrollContainer) {
//                 e.preventDefault();
//                 scrollContainer.scrollLeft += e.deltaY;
//             }
//         };
//         if (scrollContainer) {
//             scrollContainer.addEventListener('wheel', handleWheel, {passive: false});
//         }
//         return () => {
//             if (scrollContainer) {
//                 scrollContainer.removeEventListener('wheel', handleWheel);
//             }
//         };
//     }, []);

//     return (
//         <div className="w-full min-h-screen bg-gray-100">
//             {/* Navigation */}
//             <div className="w-full bg-white shadow-md sticky top-0 z-50">
//                 <div 
//                     ref={scrollContainterRef} 
//                     className="overflow-x-auto scrollbar-hide py-2 px-4 cursor-grab active:cursor-grabbing"
//                     onMouseDown={handleMouseDown}
//                     onMouseLeave={handleMouseLeave}
//                     onMouseUp={handleMouseUp}
//                     onMouseMove={handleMouseMove}
//                 >
//                     <ul className="flex gap-6 text-lg font-semibold items-center justify-start min-w-max select-none">
//                         <li>
//                             <ScrollLink 
//                                 to="/express-bowl" 
//                                 onClick={()=> setActiveLink("express-bowl")} 
//                                 smooth={true} 
//                                 duration={500} 
//                                 offset={-80} 
//                                 className={`${linkClass} ${activeLink === "express-bowl" ? activeLinkClass: "cursor-pointer"}`}
//                             >
//                                 Express Bowl
//                             </ScrollLink>
//                         </li>
//                         <li>
//                             <ScrollLink 
//                                 to="/menu-special"
//                                 onClick={()=> setActiveLink("menu-special")} 
//                                 smooth={true} 
//                                 duration={500} 
//                                 offset={-80} 
//                                 className={`${linkClass} ${activeLink === "menu-special" ? activeLinkClass: "cursor-pointer"}`}
//                             >
//                                 Menu Special
//                             </ScrollLink>
//                         </li>
//                         <li>
//                             <ScrollLink 
//                                 to="/menu-paket"
//                                 onClick={()=> setActiveLink("menu-paket")} 
//                                 smooth={true} 
//                                 duration={500} 
//                                 offset={-80} 
//                                 className={`${linkClass} ${activeLink === "menu-paket" ? activeLinkClass: "cursor-pointer"}`}
//                             >
//                                 Menu Paket
//                             </ScrollLink>
//                         </li>
//                         <li>
//                             <RouterLink 
//                                 to="/menu-porsi"
//                                 onClick={() => setActiveLink("menu-porsi")} 
//                                 className={`${linkClass} ${activeLink === "menu-porsi" ? activeLinkClass: "cursor-pointer"}`}
//                             >
//                                 Menu Porsi
//                             </RouterLink>
//                         </li>
//                         <li>
//                             <ScrollLink 
//                                 to="/nasi-goreng"
//                                 onClick={()=> setActiveLink("nasi-goreng")} 
//                                 smooth={true} 
//                                 duration={500} 
//                                 offset={-80} 
//                                 className={`${linkClass} ${activeLink === "nasi-goreng" ? activeLinkClass: "cursor-pointer"}`}
//                             >
//                                 Nasi Goreng
//                             </ScrollLink>
//                         </li>
//                         <li>
//                             <ScrollLink 
//                                 to="/kwetiau"
//                                 onClick={()=> setActiveLink("kwetiau")} 
//                                 smooth={true} 
//                                 duration={500} 
//                                 offset={-80} 
//                                 className={`${linkClass} ${activeLink === "kwetiau" ? activeLinkClass: "cursor-pointer"}`}
//                             >
//                                 Kwetiau
//                             </ScrollLink>
//                         </li>
//                         <li>
//                             <ScrollLink 
//                                 to="/bihun"
//                                 onClick={()=> setActiveLink("bihun")} 
//                                 smooth={true} 
//                                 duration={500} 
//                                 offset={-80} 
//                                 className={`${linkClass} ${activeLink === "bihun" ? activeLinkClass: "cursor-pointer"}`}
//                             >
//                                 Bihun
//                             </ScrollLink>
//                         </li>
//                         <li>
//                             <ScrollLink 
//                                 to="/mie"
//                                 onClick={()=> setActiveLink("mie")} 
//                                 smooth={true} 
//                                 duration={500} 
//                                 offset={-80} 
//                                 className={`${linkClass} ${activeLink === "mie" ? activeLinkClass: "cursor-pointer"}`}
//                             >
//                                 Mie
//                             </ScrollLink>
//                         </li>
//                     </ul>
//                 </div>
//             </div>

//             {/* Content */}
//             <div className="container mx-auto px-4 py-8">
//                 <div className="text-center mb-8">
//                     <h2 className="font-semibold text-3xl md:text-4xl">
//                         Express Bowl
//                     </h2>
//                 </div>
                
//                 <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//                     {menuExpress.map((item, index) => (
//                         <div 
//                             key={index}
//                             className="bg-white rounded-lg p-4 hover:shadow-md transition-shadow duration-300"
//                         >
//                             <div className="flex flex-col items-center">
//                                 <img 
//                                     src={item.image}
//                                     alt={item.title}
//                                     className="w-full h-48 md:h-64 rounded-lg object-cover shadow-md mb-4"
//                                     loading="lazy"
//                                 />
//                                 <h3 className="text-lg font-semibold">{item.title}</h3>
//                                 {item.description && (
//                                     <p className="text-gray-600">{item.description}</p>
//                                 )}
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>
            
//             <ScrollToTop/>
//         </div>
//     );
// }

// export default KategoriMenu;

import React, { useState, useEffect, useRef } from 'react';
import {Link as RouterLink} from "react-router-dom";
import {Link as ScrollLink} from "react-scroll";
import ScrollToTop from '../../components/layout/Scroll';
import Img1 from "../../assets/Menu1.jpg";
import Img2 from "../../assets/Menu2.jpg";
import Img3 from "../../assets/Menu3.jpg";


const menuExpress= [
    {
        image: Img1,
        title: "Express Bowl Ayam"
    },
    {
        image: Img2,
        title: "Express Bowl Ikan"
    
    },
    {
        image: Img3,
        title: "Express Bowl Mix",
        description: "(Udang, Ikan, dan Ayam)"
    },
];

const KategoriMenu = () => {

const [isOpen, setIsOpen] = useState(false);
const [isScrolled, setIsScrolled] = useState(false);
const [activeLink, setActiveLink] = useState("");
const scrollContainterRef = useRef(null);
const [isDragging, setIsDragging] = useState(false);
const [startX, setStartX] = useState(0);
const [scrollLeft, setScrollLeft] = useState(0);

const linkClass = `relative pb-1 font-bold hover:text-pink-700 transition-all duration-300 
whitespace-nowrap ${
    isScrolled ? "text-pink-700" : "text-black"
  } hover:after:content-[''] hover:after:h-0.5 hover:after:bg-pink-500`;

  const activeLinkClass = `after:content-[''] after:absolute 
  after:left-0 after:bottom-0 
  after:w-full after:h-0.5 after:bg-pink-200 
  after:transition-all after:duration-300`;

//style untuk nav dengan scroll horizontal
const navKategori =`w-full shadow-md top-26 left-0 z-50 p-2 px-6 flex 
justify-center items-center transition-all duration-500 bg-white`;

//Fungsi untuk handle mouse down (mulai drag)
const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - scrollContainterRef.current.offsetLeft);
    setScrollLeft(scrollContainterRef.current.scrollLeft);
};

//Funsi untuk handle mouse leave (selama drag)
const handleMouseLeave = () => {
    setIsDragging(false);
};

//Fungsi untuk handle mouse up (akhir drag)
const handleMouseUp =() =>{
    setIsDragging(false);
};

//fungsi untuk handle mouse move (selama drag)
const handleMouseMove = (e) => {
    if (!isDragging) return;
    const x = e.pageX - scrollContainterRef.current.offsetLeft;
    const walk = (x - startX) *2; //multiply for faster scroll
    scrollContainterRef.current.scrollLeft = scrollLeft - walk;
};

//efek untuk scroll horizontal dengan mouse wheel
useEffect(() =>{
    const scrollContainer = scrollContainterRef.current;
    const handleWheel =(e) => {
        if (scrollContainer) {
            e.preventDefault();
            scrollContainer.scrollLeft += e.deltaY;
        }
    };
    if (scrollContainer){
        scrollContainer.addEventListener('wheel', handleWheel, {passive: false});
    }
    return () => {
        if (scrollContainer) {
            scrollContainer.removeEventListener('wheel', handleWheel);
        }
    };

}, []);

  return (
    <nav className={navKategori}>
        <div className='w-full min-h-screen'>
    <div className='w-screen relative bg-gray-200 sticky top-16 z-40'>
        <div ref={scrollContainterRef} 
        className='bg-yellow-400 max-w-screen overflow-x-auto mx-auto scrollbar-hide py-2 px-4 cursor-grap active:cursor-grabing'
        onMouseDown={handleMouseDown}
        onMouseLeave={handleMouseLeave}
        onMouseUp={handleMouseUp}
        onMouseMove={handleMouseMove}
        >
    <ul className='hidden md:flex gap-6 text-xl font-semibold items-center justify-start md:justify-center min-w-max select-none md:absolute'>
        <li>
            <ScrollLink 
            to="/express-bowl" 
            onClick={()=> setActiveLink("express-bowl")} 
            smooth={true} 
            duration={500} 
            offset={-80} 
            className={`${linkClass} ${activeLink === "express-bowl" ? activeLinkClass: "cursor-pointer"}`}
            >
            Express Bowl
            </ScrollLink>
        </li>
        <li>
            <ScrollLink 
            to="/menu-special"
            onClick={()=> setActiveLink("menu-special")} 
            smooth={true} 
            duration={500} 
            offset={-80} 
            className={`${linkClass} ${activeLink === "menu-special" ? activeLinkClass: "cursor-pointer"}`}>
            Menu Special
            </ScrollLink>
        </li>
        <li>
            <ScrollLink 
            to="/menu-paket"
            onClick={()=> setActiveLink("menu-paket")} 
            smooth={true} 
            duration={500} 
            offset={-80} 
            className={`${linkClass} ${activeLink === "menu-paket" ? activeLinkClass: "cursor-pointer"}`}>
            Menu Paket
            </ScrollLink>
        </li>
        <li>
            <RouterLink 
            to="/menu-porsi"
            onClick={() => setActiveLink("menu-porsi")} 
            smooth={true} 
            duration={500} 
            offset={-80} 
            className={`${linkClass} ${activeLink === "menu-porsi" ? activeLinkClass: "cursor-pointer"}`}>
            Menu Porsi
            </RouterLink>
        </li>
        <li>
            <ScrollLink 
            to="/nasi-goreng"
            onClick={()=> setActiveLink("nasi-goreng")} 
            smooth={true} 
            duration={500} 
            offset={-80} 
            className={`${linkClass} ${activeLink === "nasi-goreng" ? activeLinkClass: "cursor-pointer"}`}>
            Nasi Goreng
            </ScrollLink>
        </li>
        <li>
            <ScrollLink 
            to="/kwetiau"
            onClick={()=> setActiveLink("kwetiau")} 
            smooth={true} 
            duration={500} 
            offset={-80} 
            className={`${linkClass} ${activeLink === "kwetiau" ? activeLinkClass: "cursor-pointer"}`}>
            Kwetiau
            </ScrollLink>
        </li>
        <li>
            <ScrollLink to="/express-bowl" smooth={true} duration={500} offset={-80} className={`${linkClass} ${activeLink === "express-bowl" ? activeLinkClass: "cursor-pointer"}`}>
            Bihun
            </ScrollLink>
        </li>
        <li>
            <ScrollLink to="/express-bowl" smooth={true} duration={500} offset={-80} className={`${linkClass} ${activeLink === "express-bowl" ? activeLinkClass: "cursor-pointer"}`}>
            Mie
            </ScrollLink>
        </li>
        <li>
            <ScrollLink to="/express-bowl" smooth={true} duration={500} offset={-80} className={`${linkClass} ${activeLink === "express-bowl" ? activeLinkClass: "cursor-pointer"}`}>
            Lo Mie & I Fu Mie
            </ScrollLink>
        </li>
        <li>
            <ScrollLink to="/express-bowl" smooth={true} duration={500} offset={-80} className={`${linkClass} ${activeLink === "express-bowl" ? activeLinkClass: "cursor-pointer"}`}>
            Menu Lain
            </ScrollLink>
        </li>
        <li>
            <ScrollLink to="/express-bowl" smooth={true} duration={500} offset={-80} className={`${linkClass} ${activeLink === "express-bowl" ? activeLinkClass: "cursor-pointer"}`}>
            Snack
            </ScrollLink>
        </li>
        <li>
            <ScrollLink to="/express-bowl" smooth={true} duration={500} offset={-80} className={`${linkClass} ${activeLink === "express-bowl" ? activeLinkClass: "cursor-pointer"}`}>
            Minuman
            </ScrollLink>
        </li>
        <li>
            <ScrollLink to="/express-bowl" smooth={true} duration={500} offset={-80} className={`${linkClass} ${activeLink === "express-bowl" ? activeLinkClass: "cursor-pointer"}`}>
            Special Drink
            </ScrollLink>
        </li>
    </ul>
    </div>
    </div>
    <div className='pt-8 text-center'>
        <h2 className='font-semibold text-4xl'>
            Express Bowl
        </h2>
    </div>
    <div className="py-16 px-4 md:px-16 min-h-screen overflow-hidden">
        <div className='flex justify-center'>
        <div className='grid grid-cols-1 md:grid-cols-3 gap-3 max-w-6xl '>
            {menuExpress.map((item, index) => (
              <div 
              key={index}
              className="w-[68vh] rounded-lg p-4 hover:shadow-lg transition-shadow duration-300 flex flex-cols"
              >
                <div className="flex-grow w-[68vh] cursor-pointer">
                    <img src={item.image}
                        alt={item.title}
                        className='w-[68vh] h-[48vh] md:h-[68vh] rounded-lg object-cover shadow-md mb-4'
                        loading='lazy'/>
                        <h3 className='text-lg font-semibold text-center mb-2'>{item.title}</h3>
                        {item.description && (
                            <p className='text-black text-center'>
                           {item.description} 
                        </p>
                        )}     
            </div>
            </div>
            ))}
    </div>
    </div>
    </div>
    <ScrollToTop/>
    </div>
    </nav>
    
    
)
}

export default KategoriMenu